// extracted by mini-css-extract-plugin
export default {"header":"asf3Cz4CQpjcQKy9Ib5r","templateAction":"YWclxsfAonGm1OwDop6b"};